module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('div', {
    attrs: {
      "id": "sidebar-wrapper"
    }
  }, [_c('ul', {
    staticClass: "sidebar-nav",
    staticStyle: {
      "margin-top": "45px"
    }
  }, [_c('li', {
    staticClass: "sidebar-brand"
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("\n                      Save/Load Goes Here\n                  ")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f5b83e26","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Sidebar.vue
// module id = 206
// module chunks = 1